// extracted by mini-css-extract-plugin
module.exports = {"root":"container_root__rLGco","wide":"container_wide__KzLyX","full":"container_full__VKJd9"};